import { mapGetters } from "vuex";
import { types as Pickup } from "@/store/pickup";
const getters = mapGetters({
    getLogistics: Pickup.LOGISTICS, // 物流详情
});
export default {
    name: "pickupLogistics",
    data() {
        return {};
    },
    computed: {
        ...getters,
    },
};
